import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';

function BetaServerCard({ server }) {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="card p-6"
    >
      <div className="flex items-center gap-4 mb-4">
        <img 
          src={server.icon} 
          alt={`${server.name} icon`}
          className="w-16 h-16 rounded-xl"
        />
        <div>
          <h3 className="text-xl font-semibold text-gray-custom-100">{server.name}</h3>
          <p className="text-gray-custom-400">Joined Beta: {server.joinDate}</p>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-4">
        <img 
          src={server.ownerIcon} 
          alt={`${server.ownerName}'s avatar`}
          className="w-6 h-6 rounded-full"
        />
        <span className="text-sm text-gray-custom-400">{server.ownerName}</span>
      </div>

      <p className="text-gray-custom-400 mb-4 italic">"{server.statement}"</p>

      {server.featuredLink && (
        <div className="mb-4">
          <a
            href={server.featuredLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-custom-400 hover:text-white transition-colors flex items-center gap-2"
          >
            <span className="text-sm font-medium">Featured Link:</span>
            <span className="text-sm underline">{server.featuredLink}</span>
          </a>
        </div>
      )}

      <a
        href={server.inviteLink}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary w-full text-center"
      >
        Join Server
      </a>
    </motion.div>
  );
}

function Beta() {
  const betaServers = [
    {
      name: "Discord Wrapped",
      icon: "https://cdn.wrappedbot.com/Wrapped%20Mascot%20Icon",
      ownerName: "Taco",
      ownerIcon: "https://cdn.wrappedbot.com/Taco_pfp_2.png",
      joinDate: "May 4, 2025",
      inviteLink: "https://discord.gg/example",
      statement: "Overseer has been an incredible addition to our server. The moderation features are top-notch!",
      featuredLink: "https://wrappedbot.com"
    }
    // More servers will be added here
  ];

  return (
    <div>
      <div className="container-custom py-24">
        <div className="text-center mb-16">
          <h1 className="heading-1 text-gray-custom-100 mb-4">Beta Supporters</h1>
          <p className="text-xl text-gray-custom-400 max-w-3xl mx-auto">
            These servers helped shape Overseer during its early development. Join them to experience Overseer in action and see how it's being used in real communities!
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {betaServers.map((server, index) => (
            <BetaServerCard key={index} server={server} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Beta; 